<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2022-02-23 15:35:07
 * @LastEditTime: 2022-11-02 16:16:31
 * @Description: 供应计划
 * @Param:
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\supplyPlan\index.vue
 -->

<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles supplyPlan">
            <van-nav-bar
                title=""
                left-text="应用"
                left-arrow
                @click-left="swiperright"
            >
                <template #title>
                    <div
                        :class="{'active': listType == 'db'}"
                        @click="listSwitch('db')"
                    >
                        待审批
                    </div>
                    <div
                        :class="{'active': listType == 'yb'}"
                        @click="listSwitch('yb')"
                    >
                        已审批
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                        :immediate-check="false"
                    >
                        <ul class="list">
                            <template v-for="(item, index) in listData">
                                <li
                                    :key="index"
                                    class="approval"
                                    @click="openplanDetails(item, index)"
                                >
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header" :class="approvalStatusStyle(item.approval_status)">
                                            <span class="state" v-if="item.approval_status != 0">
                                                <i v-if="item.approval_status == 0">未审批</i>
                                                <i v-if="item.approval_status == 2">审批通过</i>
                                                <i v-if="item.approval_status == 3">审批未通过</i>
                                            </span>
                                            <span class="headerName">
                                                <template v-if="item.procurement_type == 1">场站信息：</template>
                                                <template v-if="item.procurement_type == 2">申请场站：</template>
                                                {{ item.station_name }}
                                            </span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_7.png" alt="">
                                                <span>供应日期：{{ item.supply_date | formatTime }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_7.png" alt="">
                                                <span>要求送货时间：{{ item.time_required }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_3.png" alt="">
                                                <span>申请人：{{ item.operation_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_7.png" alt="">
                                                <span>申请时间：{{ item.operation_date }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_4.png" alt="">
                                                <span>备注：{{ item.remarks }}</span>
                                            </p>
                                            <p class="approvalOpinions" v-if="item.approval_opinions && item.approval_status != 0">
                                                审批意见：{{ item.approval_opinions }}
                                            </p>
                                            <span class="materialType" :class="materialTypeClass(item.procurement_type)">
                                                <i v-if="item.procurement_type == 0">所有</i>
                                                <i v-if="item.procurement_type == 1">骨料</i>
                                                <i v-if="item.procurement_type == 2">粉料、外加剂等</i>
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>
<script>
import Utils from '@/utils/util.js';

export default {
    name: 'supply-plan',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'supply-plan');
        }
        next();
    },
    props: {},
    data() {
        return {
            value: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 上拉索引
            count: 1,
            // 列表总条数
            total: 0,
            // 是否已加载完所有数据
            finished: false,
            // 当前打开列表类型，db待办，yb已办
            listType: 'db',
            // 列表数据
            listData: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        this.init();
    },
    activated() {
        // 审批完成返回
        if (this.$route.params.approvalCompleted) {
            this.listData.splice(this.$route.params.listIndex, 1);
        }
    },
    mounted() {},
    filters: {
        // 格式化显示供应日期
        formatTime(time) {
            if ((time || '') !== '') {
                const newDate = time.split(' ');
                return newDate[0];
            }
            return '';
        },
    },
    destroyed() {},
    methods: {
        // 首次加载
        async init() {
            this.gitListData();
            this.$toast.clear();
        },
        // 返回上级页面
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 下拉刷新
        onRefresh() {
            this.count = 1;
            this.listData = [];
            this.gitListData();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            this.gitListData();
        },
        // 待办已办切换
        listSwitch(obj) {
            this.count = 1;
            this.listData = [];
            this.listType = obj;
            this.finished = false;
            this.gitListData();
        },

        // 审批状态样式
        approvalStatusStyle(approval_status) {
            let returnData = '';
            if (approval_status === 2) {
                returnData = 'adopt';
            } else if (approval_status === 3) {
                returnData = 'fail';
            }
            return returnData;
        },

        // 材料类型
        materialTypeClass(procurementType) {
            let returnData = '';
            if (procurementType === 1) {
                returnData = 'materialType1';
            } else if (procurementType === 2) {
                returnData = 'materialType2';
            }
            return returnData;
        },

        // 打开计划详情页面
        openplanDetails(data, index) {
            let routerName = '';
            if (data.procurement_type === 1) {
                routerName = 'planDetails_gl';
            } else if (data.procurement_type === 2) {
                routerName = 'planDetails_fl';
            }
            this.$router.isBack = 2;
            this.$router.push({
                name: 'planDetails',
                params: {
                    listIndex: index,
                    listType: this.listType,
                    pageName: routerName,
                    plan_id: data.id,
                },
            });
        },
        // 获取列表数据
        gitListData() {
            let requestUrl = '';
            if (this.listType === 'db') {
                requestUrl = '/daily/plan/getpage/notapproved';
            } else if (this.listType === 'yb') {
                requestUrl = '/daily/plan/getpage/approved';
            }
            this.$axios.get(`/interfaceApi/procurement/${requestUrl}?pageindex=${this.count}&pagesize=4`)
                .then(res => {
                    this.total = res.total;
                    this.listData.push(...res.rows || []);
                    this.finished = this.listData.length >= this.total;
                    this.isLoading = false;
                    this.isUpLoading = false;
                }) .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus" scoped>
.supplyPlan
    height 100%
    position relative
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    section
        height calc(100% - 45rpx)
        overflow: hidden;
        .van-pull-refresh
            height 100%
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                background #F0F0F0
                padding 15rpx
                padding-bottom 0
                min-height 100%
                overflow hidden
                li
                    width 100%
                    background #fff
                    margin-bottom 15rpx
                    h4
                        &.adopt
                            .state
                                background-color #2EBA9B
                        &.fail
                            .state
                                background-color #F85B5B
                        .text
                            font-size 16rpx
                    .engineeringInfo_content
                        position: relative
                        .materialType
                            height: 22rpx
                            font-size 12rpx
                            line-height 20rpx
                            padding: 0 8rpx
                            position: absolute
                            top 10rpx
                            right 10rpx
                            &:before
                                font-size 10rpx
                                position absolute
                                right 100%
                            &.materialType1
                                color #FA6400
                                background: #FEF3EB
                                border 1px solid #F4D8C6
                                &:before
                                    color #F4D8C6
                            &.materialType2
                                color #00A984
                                background: #DEF4EF
                                border 1px solid #B7E7DC
                                &:before
                                    color #B7E7DC
                        .approvalOpinions
                            background: #FFFBE6
                            padding 10rpx
                            font-size 14rpx
                            color #FF9701
                            line-height: 20rpx
        >div
            height 100%
            .noData
                font-size 40rpx
                line-height 200rpx
                font-weight 600
                color #ccc
                text-align center
</style>